//Remove Setting component when this component is stable as this component was replaced from settings.


import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { IonContent, Platform } from "@ionic/angular";
import { Navigator } from "src/app/components/menu/navigator";
import { CustomerModel } from "src/app/models/customer-model";
import { AppLinksService } from "src/app/services/applinks/app-links.service";
import { AppstorageTsService } from "src/app/services/appstorage/appstorage.ts.service";
import { isUndefined } from "src/app/services/codeUtils";
import { SiteMenuService } from "src/app/services/sitemenu/sitemenu.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { BiometricService } from 'src/app/services/biometric/biometric.service';
import { SocialAuthService } from 'src/app/services/authentication/social-auth.service';
import { BoydRewardsService } from "src/app/services/boyd-rewards/boyd-rewards.service";
import { Subscription } from "rxjs";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";

@Component({
    selector: 'app-site-menu',
    templateUrl: './site-menu.component.html',
    styleUrls: ['./site-menu.component.scss'],
})

export class SiteMenuComponent implements OnInit, OnDestroy {
    @ViewChild(IonContent, { static: false }) content: IonContent;

    protected userID: number;
    protected isAuthenticated: boolean = false;

    public customer: CustomerModel;
    public siteMenu: any[] = [];
    public isCustomerHasEmail: boolean = null;
    public isMobileApp: boolean;
    public playerHasRewardCard: boolean = false;
    public versionNumber: string;
    public isPlayerLoggedInAsGuest: boolean = false;
    public isPlayerLoggedInAsSocial: boolean = false;
    public isPlayerLoggedIn: boolean = false;
    public playAsGuestEnabled: boolean = false;
    private rewardStatusSubscription: Subscription;

    constructor(
        private readonly links: AppLinksService,
        private readonly menu: SiteMenuService,
        private readonly navigator: Navigator,
        private readonly platform: Platform,
        private readonly userSessionService: UserSessionService,
        private biometricService: BiometricService,
        private socialAuthService: SocialAuthService,
        private appStorageService: AppstorageTsService,
        private boydRewardService: BoydRewardsService,
        private authService: AuthenticationService
    ) {
        this.verifyAuth();
        this.playAsGuestEnabled = this.socialAuthService?.playAsGuestEnabled;
        this.siteMenu = this.menu.getSiteMenu();
        this.getCustomer();
        this.rewardStatusSubscription = this.boydRewardService.getRewardCardStatus().subscribe((hasRewardCard) => {
            this.playerHasRewardCard = hasRewardCard;
        });
    }

    async ngOnInit(): Promise<any> {
        this.versionNumber = await this.menu.getAppVersion();

        this.checkBiometricAndMobileApp();
        this.checkGuestPlayer();
        this.checkSocialPlayer();
        this.checkButtonStatus();
    }

    private checkButtonStatus(): any {
        this.logoutButtonStatus();
        this.deleteButtonStatus();
    }

    public logoutButtonEnabled: boolean = false;
    private logoutButtonStatus(): any {
        if (this.isPlayerLoggedInAsGuest) return (this.logoutButtonEnabled = false);
        this.logoutButtonEnabled = this.isAuthenticated;
        return;
    }

    public deleteButtonEnabled: boolean = false;
    private deleteButtonStatus(): any {
        this.deleteButtonEnabled = this.isAuthenticated && this.isMobileApp;
        return;
    }

    private getCustomer(): any {
        this.userSessionService.getCustomerPromise().then((customer: CustomerModel) => {
            if (customer) {
                this.customer = customer;
                this.isCustomerHasEmail = isUndefined(customer.email)
                this.userID = customer.customerId;
                this.isPlayerLoggedIn = true;
                this.checkRewardCard();
            } else {
                this.isPlayerLoggedIn = false;
            }
        }).catch(error => {
            console.error('something went wrong', error)
        });
    }

    private async checkBiometricAndMobileApp(): Promise<any> {
        this.isMobileApp = this.platform.is("capacitor");
        if (this.isMobileApp) {
            await this.checkBiometricAvailable();
        }
    }

    async checkBiometricAvailable() {
        await this.biometricService.isAvailable();
    }

    private checkRewardCard(): any {
        this.authService.checkPlayerHasRewardCard().subscribe(
            (response) => {
                if (response && !!response.result) {
                    this.playerHasRewardCard = response.payload;
                }
            },
            (error) => {
                this.playerHasRewardCard = false;
            }
        );
    }

    private checkSocialPlayer(): any {
        this.appStorageService.getPlayerAsSocial().then((isSocial) => {
            if (isSocial.value === 'true') return this.isPlayerLoggedInAsSocial = true;
            return this.isPlayerLoggedInAsSocial = false;
        });
    }

    private async checkGuestPlayer(): Promise<void> {
        try {
            const isGuest = await this.appStorageService.getPlayerAsGuest();
            this.isPlayerLoggedInAsGuest = isGuest.value === 'true';
            this.checkButtonStatus();
        } catch (error) {
            this.isPlayerLoggedInAsGuest = false;
        }
    }

    private verifyAuth(): any {
        this.userSessionService.isAuthenticated().then((auth) => {
            if (auth) return this.isAuthenticated = true;
            return this.isAuthenticated = false;
        })
    }

    protected goToLink(url: string): any {
        return this.links.openExternalPage(url);
    }

    protected goToPage(page: string): any {
        const modalOptions: any = { customModalClass: 'crown-modal', multipleModals: true };
        return this.navigator.navigateTo(page, modalOptions);
    }

    ngOnDestroy(): void {
        this.rewardStatusSubscription?.unsubscribe();
    }
}